module.exports = __webpack_public_path__ + "img/banner_1.18e931a2.webp";